import { FC, useMemo } from 'react'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import {
  ImageTransformer,
  unwrapMedia,
} from 'src/relay/Transformers/ImageTransformer'
import SinglePush, { SinglePushProps } from 'src/components/SinglePush'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'
import { ActionIconBackground } from '../../../components/ActionButton/types'

import { PictureTextCtaProps } from './props'

const PictureTextCtaBlock: FC<BlockProps<PictureTextCtaProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const props: SinglePushProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          tag: data.sectionTitle || '',
          title: data.title,
          color: getThemeColor(data.theme?.data),
        },
      }),
      ...(data.text && {
        richTextProps: RichTextTransformer(data.text, configuration, locale),
      }),
      ...(data.cta && {
        actionButtonProps: ButtonTransformer({
          data: data.cta,
          theme: data.theme?.data,
          iconBackground: data.theme?.data
            ? ActionIconBackground.color
            : ActionIconBackground.default,
        }),
      }),
      pictureProps: {
        imageProps: ImageTransformer(unwrapMedia(data.desktopImage), {
          tablet: '100vw, 75vw',
        }),
        mobileImageProps: ImageTransformer(unwrapMedia(data.mobileImage), {
          tablet: '100vw, 75vw',
        }),
      },
      color: getThemeColor(data.theme?.data),
    }),
    [configuration, data, locale]
  )

  return <SinglePush {...props} />
}

export default PictureTextCtaBlock
